import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'

import 'bootstrap'
import './assets/events/1/style.scss'
import './assets/custom-basic.css'
import './assets/events/1/custom.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'tom-select/dist/css/tom-select.bootstrap5.css'

const app = createApp(App)


let apiPath = "https://api.tescocsapatnap.hu"
const hostName = window.location.hostname
if(hostName === 'localhost' || hostName.includes('fejlesztes')){
    apiPath = "https://api-test.csapatnap.hu"
}

axios.defaults.baseURL = apiPath
axios.defaults.withCredentials = true
app.config.globalProperties.$axios = axios
app.config.globalProperties.$myApiKey = process.env.VUE_APP_API_MY_KEY
axios.defaults.headers.common['TestHash'] = process.env.VUE_APP_API_MY_KEY

app.use(router,axios)
app.mount('#app')
